const Detector = require('./base.js');

const SYNONYMS = [
  'layaway',
  'layway',
  'lay a way',
  'lay away',
  'lay-a-way',
  'lay-away',
];
const NAMESPACE = 'layaway';

module.exports = new Detector(SYNONYMS, NAMESPACE);



// WEBPACK FOOTER //
// ./javascripts/components/detector/layaway.js